import * as forge from "@tylertech/forge";

forge.defineAccordionComponent();
forge.defineAppBarProfileButtonComponent();
forge.defineAutocompleteComponent();
forge.defineAvatarComponent();
forge.defineBadgeComponent();
forge.defineBannerComponent();
forge.defineButtonComponent();
forge.defineCardComponent();
forge.defineCheckboxComponent();
forge.defineChipComponent();
forge.defineChipSetComponent();
forge.defineCircularProgressComponent();
forge.defineColorPickerComponent();
forge.defineDatePickerComponent();
forge.defineDividerComponent();
forge.defineDrawerComponent();
forge.defineExpansionPanelComponent();
forge.defineFilePickerComponent();
forge.defineFloatingActionButtonComponent();
forge.defineFocusIndicatorComponent();
forge.defineIconButtonComponent();
forge.defineIconComponent();
forge.defineInlineMessageComponent();
forge.defineLabelValueComponent();
forge.defineLinearProgressComponent();
forge.defineListComponent();
forge.defineListItemComponent();
forge.defineMenuComponent();
forge.defineOpenIconComponent();
forge.definePageStateComponent();
forge.definePaginatorComponent();
forge.definePopoverComponent();
forge.defineScaffoldComponent();
forge.defineSelectComponent();
forge.defineSkeletonComponent();
forge.defineStateLayerComponent();
forge.defineStepperComponent();
forge.defineSwitchComponent();
forge.defineTabBarComponent();
forge.defineTabComponent();
forge.defineTableComponent();
forge.defineTextFieldComponent();
forge.defineTimePickerComponent();
forge.defineToolbarComponent();
forge.defineTooltipComponent();
forge.defineSkipLinkComponent();
